<template>
  <div class="amendments-filter filters-container">
    <select-filter
      type="amendments"
      field="status"
      label="Статус"
      request="objectInfo/contract_statuses"
      :parse-value="({ name }) => name"
    />
    <sorting-control
      style="margin-left: 32px;"
      type="amendments"
      :values="sortingFields"
    />
  </div>
</template>

<script>
import SelectFilter from './helpers/select-filter'
import SortingControl from './helpers/sorting-control'

const sortingFields = [
  { field: 'date', name: 'Дата' }
]

export default {
  components: {
    SelectFilter,
    SortingControl
  },
  data () {
    return {
      sortingFields
    }
  }
}
</script>

<style></style>
